import request from '@/utils/request.js'
// 查询OssToken
export function fetchOssToken() {
  return request.get('server/oss_token')
}
// 查看大图
// export function getLargerVersion(url, params) {
//   return request.get(`${url}?x-oss-process=image/info`, {
//     ...params,
//   })
// }


// WEBPACK FOOTER //
// ./src/api/upload.js